import { useEditorStore, type InspectorTab } from '../../state/editorStore';
import { AudioPanel } from '../panels/AudioPanel';
import { ColorPanel } from '../panels/ColorPanel';
import { CompositionPanel } from '../panels/CompositionPanel';
import { EffectsPanel } from '../panels/EffectsPanel';
import { ExportPanel } from '../panels/ExportPanel';
import { KeyframesPanel } from '../panels/KeyframesPanel';
import { ScopesPanel } from '../panels/ScopesPanel';
import { TextPanel } from '../panels/TextPanel';
import { TransformPanel } from '../panels/TransformPanel';
import { ResizeHandle } from './ResizeHandle';

const TABS: { id: InspectorTab; label: string }[] = [
  { id: 'transform', label: 'Video' },
  { id: 'color', label: 'Color' },
  { id: 'effects', label: 'Effects' },
  { id: 'audio', label: 'Audio' },
  { id: 'text', label: 'Text' },
  { id: 'keyframes', label: 'Animate' },
  { id: 'comp', label: 'Project' },
  { id: 'export', label: 'Export' },
];

export function InspectorPanel() {
  const tab = useEditorStore((s) => s.inspectorTab);
  const setInspectorTab = useEditorStore((s) => s.setInspectorTab);
  const hasScopes = useEditorStore((s) => s.hasPanel('scopes'));
  const scopesHeight = useEditorStore((s) => s.panelSizes.scopesHeight);
  const setPanelSize = useEditorStore((s) => s.setPanelSize);

  return (
    <div className="flex h-full min-h-0 flex-col bg-panel">
      <div className="flex shrink-0 flex-wrap gap-0.5 border-b border-hairline px-1.5 py-1.5">
        {TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            onClick={() => setInspectorTab(t.id)}
            className={`shrink-0 rounded-lg px-2.5 py-1.5 text-2xs font-medium ${
              tab === t.id
                ? 'bg-raised text-text-high'
                : 'text-text-low hover:bg-raised/60 hover:text-text-high'
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>
      <div className="min-h-0 flex-1 overflow-hidden">
        {tab === 'color' && (
          <div className="flex h-full min-h-0 flex-col">
            {hasScopes && (
              <>
                <div className="shrink-0 overflow-hidden" style={{ height: scopesHeight }}>
                  <ScopesPanel />
                </div>
                <ResizeHandle
                  orientation="horizontal"
                  value={scopesHeight}
                  min={96}
                  max={420}
                  onChange={(v) => setPanelSize('scopesHeight', v)}
                />
              </>
            )}
            <div className="min-h-0 flex-1 overflow-hidden">
              <ColorPanel />
            </div>
          </div>
        )}
        {tab === 'transform' && <TransformPanel />}
        {tab === 'effects' && <EffectsPanel />}
        {tab === 'audio' && <AudioPanel />}
        {tab === 'text' && <TextPanel />}
        {tab === 'keyframes' && <KeyframesPanel />}
        {tab === 'comp' && <CompositionPanel />}
        {tab === 'export' && <ExportPanel />}
      </div>
    </div>
  );
}
